import React from 'react';
import { useTheme } from '@mui/material';
import DSDialog from '../../design-system/DSDialog';
import DSDialogTitle from '../../design-system/DSDialogTitle';
import DSDialogContent from '../../design-system/DSDialogContent';
import DSDialogActions from '../../design-system/DSDialogActions';
import { DSTypography } from '../../design-system/Typography';
import DSBox from '../../design-system/DSBox';
import DSCheckBox from '../../design-system/DSCheckBox';
import DSPrimaryButton from '../../design-system/DSPrimaryButton';
import DSSecondaryButton from '../../design-system/DSSecondaryButton';

type FinalConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onOpenTerms: () => void;
  termsAccepted: boolean;
  onTermsAcceptedChange: (accepted: boolean) => void;
  showTermsError: boolean;
  loading?: boolean;
};

const FinalConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  onOpenTerms,
  termsAccepted,
  onTermsAcceptedChange,
  showTermsError,
  loading = false,
}: FinalConfirmationDialogProps) => {
  const { palette } = useTheme();

  return (
    <DSDialog open={open} onClose={onClose}>
      <DSDialogTitle>Final Confirmation</DSDialogTitle>
      <DSDialogContent>
        <DSTypography sx={{ marginBottom: 2 }}>
          Clicking Done will finalize all changes. You won't be able to make
          further edits after confirming. Are you sure you want to continue?
        </DSTypography>
        <DSBox sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DSCheckBox
            checked={termsAccepted}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onTermsAcceptedChange(e.target.checked)
            }
            sx={{ padding: 0 }}
          />
          <DSTypography sx={{ fontSize: 13 }}>I agree to the</DSTypography>
          <DSTypography
            onClick={onOpenTerms}
            sx={{
              fontSize: 13,
              cursor: 'pointer',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            Terms and Conditions
          </DSTypography>
        </DSBox>
        <DSTypography
          sx={{
            fontSize: 13,
            color: palette.error.main,
            marginLeft: 4,
            visibility: showTermsError ? 'visible' : 'hidden',
            height: '1.2em',
          }}
        >
          {showTermsError
            ? 'Please accept the terms and conditions to continue'
            : ' '}
        </DSTypography>
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton onClick={onClose} disabled={loading}>
          Cancel
        </DSSecondaryButton>
        <DSPrimaryButton onClick={onConfirm} disabled={loading}>
          Done
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default FinalConfirmationDialog;
